<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3 card-style">
          <div slot="header" class="row">
            <div class="col-6">
              <h4 class="card-title f-20-mobile">Tags</h4>
            </div>
            <div class="col-6 text-right">
              <router-link to="/tag-insertion" class="btn btn-primary">Nova</router-link>
            </div>
          </div>
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Nome</th>
                <th class="text-center">Alcance</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tag of tags">
                <td>{{ tag.name }}</td>
                <td align="center">{{ tag.idiList.length}}</td>
              </tr>
              <tr v-if="!tags || !tags.length">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>
        </card>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { Card } from 'src/components'
import moment from 'moment'

export default {
    components: {
      Card,
      moment
    },
    data() {
      return {
        tags: [],
      }
    },
    methods:{
      changePage(page) {
        this.current_page = page
        this.load()
      },

      filtrar() {
        this.load()
      },

      load() {
        axios.get(process.env.VUE_APP_NEST_CAMPAIGN + 'tag/installations').then(res => {
          this.tags = res.data
        }).catch(err => {
          console.error(err)
        });
      },

    },
    mounted() {
      this.load()
    }
}
</script>

<style>
.card-style {
  margin-top: 15px;
  height: 550px;
  overflow-y: auto;
}

.text-center {
  text-align: center;
}
</style>
